<template>
    <el-drawer title="История звонков" :visible.sync="visibleModalModel" :size="'450px'" :direction="'rtl'" id="modal_call_history">
        <div v-loading="loading" style="min-height: 50px">

            <div>
<!--                -->
                <button :class="{[`btn-prepared-filter-active`]: filter_missed_only_new_requests}" class="btn btn-prepared-filter d-inline mt-1 mb-3" @click="filter_missed_only_new_requests = !filter_missed_only_new_requests">Пропущенные по новым заявкам</button>
            </div>

            <template v-for="dataDay in filteredList">
                <span class="text-muted h4">{{dataDay[0][0].called_date}}</span>
                <el-collapse class="call-history-collapse mb-3">
                    <template v-for="call_group_item in dataDay">
                        <el-collapse-item :name="call_group_item[0].request_id + call_group_item[0].called_date" >
                            <template slot="title">
                                <div class="row w-100 h-auto">
                                    <div class="col-9">
                                        <div><router-link :class="{'text-danger': call_group_item[0].isMissed}" :to="{name: 'request', params: {id: call_group_item[0].request_id}}">№{{call_group_item[0].request_id}}</router-link> <RequestStatusBadge class="d-inline-block" style="width: 100px" :slug="call_group_item[0].request.status" /></div>
                                        <div><span class="font-weight-bold" :class="{'text-danger': call_group_item[0].isMissed}">{{call_group_item[0].request.fio}}</span></div>
                                        <div><span class="text-muted">Оператор: {{call_group_item[0].request.operator ? call_group_item[0].request.operator.name : 'Не назначен'}}</span></div>
                                        <div>
                                            <PhoneIncomingIcon v-if="call_group_item[0].direction === 'IN' && call_group_item[0].status !== 'NO_ANSWER'" class="text-success"/>
                                            <PhoneOutgoingIcon v-if="call_group_item[0].direction === 'OUT'" class="text-primary"/>
                                            <PhoneMissedIcon v-if="call_group_item[0].direction === 'IN' && call_group_item[0].status === 'NO_ANSWER'" class="text-danger"/>
                                            <span :class="{'text-danger': call_group_item[0].isMissed, 'text-muted': !call_group_item[0].isMissed}" class="small">{{phoneView(call_group_item[0].direction === 'IN' ? call_group_item[0].src : call_group_item[0].dst)}}</span>
                                            <span v-if="call_group_item[0].user" class="text-muted small badge badge-light">{{call_group_item[0].user.name}}</span>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <span class="text-muted">{{call_group_item[0].called_time}}</span>
                                        <span v-if="call_group_item.length > 1">({{call_group_item.length}})</span>
                                        <span :class="{'text-danger': call_group_item[0].isMissed, 'text-muted': !call_group_item[0].isMissed}" class="small d-block">{{call_group_item[0].status_label}}</span>
                                    </div>
                                </div>
                            </template>
                            <el-timeline class="pt-2">
                                <template v-for="call in call_group_item">
                                    <el-timeline-item class="pb-2">
                                        <div>
                                            <div>
                                                <span class="text-muted">{{call.called_time}}</span>
                                                <PhoneIncomingIcon v-if="call.direction === 'IN' && call.status !== 'NO_ANSWER'" class="text-success"/>
                                                <PhoneOutgoingIcon v-if="call.direction === 'OUT'" class="text-primary"/>
                                                <PhoneMissedIcon v-if="call.direction === 'IN' && call.status === 'NO_ANSWER'" class="text-danger"/>
                                                <span :class="{'text-danger': call.isMissed, 'text-muted': !call.isMissed}">{{phoneView(call.direction === 'IN' ? call.src : call.dst)}}</span>
                                                <span :class="{'text-danger': call.isMissed}">{{call.status_label}}</span>
                                            </div>
                                            <div><span v-if="call.user" class="text-muted badge badge-light">{{call.user.name}}</span></div>
                                        </div>
                                    </el-timeline-item>
                                </template>
                            </el-timeline>
                        </el-collapse-item>
                    </template>
                </el-collapse>
            </template>
        </div>
    </el-drawer>
</template>

<script>
    import {PhoneIncomingIcon, PhoneOutgoingIcon, PhoneMissedIcon} from "vue-feather-icons";
    import RequestStatusBadge from "./requests/RequestStatusBadge";
    export default {
        name: "ModalCallHistory",
        components: {RequestStatusBadge, PhoneIncomingIcon, PhoneOutgoingIcon, PhoneMissedIcon},
        props: ['visibleModal'],
        data: () => ({
            list: [],
            loading: false,

            filter_missed_only_new_requests: false,
            missed_only_new_requests: [],
            missed_only_new_requests_interval: null,
        }),
        mounted() {
            this.appendCallList();
            this.$bus.$emit('call_history:open_modal');

            let self = this;
            this.missed_only_new_requests_interval = setInterval(function () {
                if (self.filter_missed_only_new_requests) self.fetchMissedOnlyNewRequests(false);
            },60000);
        },
        beforeDestroy() {
            clearInterval(this.missed_only_new_requests_interval);
        },
        computed: {
            visibleModalModel: {
                get () { return this.visibleModal },
                set (value) { this.$emit('update:visibleModal', value) },
            },
            filteredList() {
                if (this.filter_missed_only_new_requests) {
                    return this.missed_only_new_requests;
                } else {
                    return this.list;
                }
            }
        },
        watch: {
            filter_missed_only_new_requests(val){
                if (val) {
                    this.fetchMissedOnlyNewRequests(true);
                }
            }
        },
        methods: {
            phoneView(phone) {
                return this.$hasPermission('request.phone.show_full.without_challenge') ? phone : this.$hidePartPhone(phone);
            },
            prepareCallList(data) {
                data = _.map(data, function (c) {
                    c.called_date = moment(c.called_at).format('YYYY-MM-DD');
                    c.called_time = moment(c.called_at).format('HH:mm');
                    c.isMissed = !!(c.direction === 'IN' && c.status === 'NO_ANSWER' && c.has_callback === 0);
                    c.request.fio = [c.request.last_name, c.request.first_name, c.request.middle_name].join(' ');
                    c.status_label = '';
                    switch (c.status) {
                        case 'NEW':
                            c.status_label = '...';
                            break;
                        case 'ANSWERED':
                            c.status_label = 'ответил';
                            break;
                        case 'NO_ANSWER':
                            c.status_label = 'не отвечает';
                            break;
                        case 'BUSY':
                            c.status_label = 'занято';
                            break;
                    }
                    if (c.isMissed) c.status_label = 'пропущенный';

                    return c;
                });
                data = data.sort(function (a, b) {
                    return moment(a.called_at)._d.getTime() < moment(b.called_at)._d.getTime() ? 1 : -1;
                });
                data = _.uniqBy(data, function (item) {
                    return item.id;
                });

                let byDate = [];
                byDate = _.groupBy(data, function (item) {
                    return moment(item.called_at).format('YYYY-MM-DD')
                });
                byDate = _.map(byDate, function (group_date) {
                    let groups = [];

                    groups = _.groupBy(group_date, function (c) {
                        return c.request_id;
                    });
                    groups = _.map(groups);

                    groups = groups.sort(function (a, b) {
                        return moment(a[0].called_at)._d.getTime() < moment(b[0].called_at)._d.getTime() ? 1 : -1;
                    });

                    return groups;
                });
                byDate = byDate.sort(function (a, b) {
                    return moment(a[0][0].called_at)._d.getTime() < moment(b[0][0].called_at)._d.getTime() ? 1 : -1;
                });

                return byDate;
            },
            appendCallList() {
                let self = this;
                this.loading = true;
                let data = [];
                axios.get('/api/calls/my')
                    .then(function (response) {
                        data = _.concat(data,response.data);
                    })
                    .then(function () {
                        return axios.get('/api/calls/missed');
                    })
                    .then(function (response) {
                        data = _.concat(data,response.data);

                        self.list = self.prepareCallList(data);
                        self.loading = false;
                    })
            },
            fetchMissedOnlyNewRequests(use_loading = true) {
                let self = this;
                if (use_loading) this.loading = true;
                axios.get('/api/calls/missed?only_new_requests=1')
                    .then(res => {
                        self.missed_only_new_requests = self.prepareCallList(res.data);
                        if (use_loading) self.loading = false;
                    })
            }
        }

    }
</script>

<style scoped>

</style>
